export const capabilities = Object.freeze({
  NEW_BOTTOM_BAR: 'new-bottom-bar-design',
  MUTE_ALL: 'force-mute',
  RECORDING_SOUND_INDICATION: 'recording-sound-indication'
});

export const ALPHA_PREFIX = 'alpha-';

export function getDefaultCapabilities() {
  return [];
}
